// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_PRESCRIPTORS,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getPrescriptors = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('prescriptors')
      .then(
        (response) => {
          dispatch(GET_PRESCRIPTORS, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/prescriptorsActions.js